import { useEffect, useState } from "react";
import { Menu, X, Phone } from "lucide-react";
import Logo from "./Logo";
import { HOTEL, NAV_LINKS } from "../data/content";

export const scrollToHash = (hash) => {
  const el = document.querySelector(hash);
  if (!el) return;
  if (window.__lenis) window.__lenis.scrollTo(el, { offset: -70 });
  else el.scrollIntoView({ behavior: "smooth" });
};

const Navbar = ({ onBook }) => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const go = (e, hash) => {
    e.preventDefault();
    setOpen(false);
    scrollToHash(hash);
  };

  return (
    <header
      data-testid="main-navbar"
      className={`fixed inset-x-0 top-0 z-50 transition-all duration-500 ${
        scrolled ? "border-b border-[#2A2421] bg-[#0D0B0A]/85 backdrop-blur-xl" : "bg-transparent"
      }`}
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-5 py-4 sm:px-8">
        <button data-testid="nav-logo-button" onClick={(e) => go(e, "#top")} className="shrink-0" aria-label="The Rayan home">
          <Logo />
        </button>

        <nav className="hidden items-center gap-8 lg:flex" data-testid="nav-links">
          {NAV_LINKS.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.label.toLowerCase()}`}
              onClick={(e) => go(e, l.href)}
              className="text-[11px] font-medium uppercase tracking-[0.28em] text-[#A8A29E] transition-colors duration-300 hover:text-[#C5A059]"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden items-center gap-5 lg:flex">
          <a
            href={HOTEL.phoneLink}
            data-testid="nav-phone-link"
            className="flex items-center gap-2 text-xs tracking-wider text-[#F5F2EB] transition-colors hover:text-[#C5A059]"
          >
            <Phone size={14} className="text-[#C5A059]" />
            {HOTEL.phoneDisplay}
          </a>
          <button
            data-testid="nav-book-button"
            onClick={onBook}
            className="border border-[#C5A059] bg-[#C5A059] px-6 py-2.5 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#0D0B0A] transition-all duration-300 hover:bg-transparent hover:text-[#C5A059]"
          >
            Reserve
          </button>
        </div>

        <button
          data-testid="nav-menu-toggle"
          className="text-[#F5F2EB] lg:hidden"
          onClick={() => setOpen(!open)}
          aria-label="Toggle menu"
        >
          {open ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {open && (
        <div data-testid="nav-mobile-menu" className="border-t border-[#2A2421] bg-[#0D0B0A]/95 px-6 py-6 backdrop-blur-xl lg:hidden">
          <div className="flex flex-col gap-5">
            {NAV_LINKS.map((l) => (
              <a
                key={l.href}
                href={l.href}
                data-testid={`nav-mobile-link-${l.label.toLowerCase()}`}
                onClick={(e) => go(e, l.href)}
                className="text-sm uppercase tracking-[0.3em] text-[#A8A29E] hover:text-[#C5A059]"
              >
                {l.label}
              </a>
            ))}
            <button
              data-testid="nav-mobile-book-button"
              onClick={() => {
                setOpen(false);
                onBook();
              }}
              className="mt-2 border border-[#C5A059] bg-[#C5A059] px-6 py-3 text-[11px] font-semibold uppercase tracking-[0.25em] text-[#0D0B0A]"
            >
              Reserve Your Stay
            </button>
          </div>
        </div>
      )}
    </header>
  );
};

export default Navbar;
